import { v4 as uuid } from "uuid";
import FormInputError from "components/General/FormInputError";

export default function DatePicker({
  labelName,
  setValue,
  register,
  validationsProps,
  name,
  min,
  max,
  validationMessage,
  isDisabled = false,
}) {
  const UUID = uuid();

  return (
    <div>
      <label id={`${UUID}-${name}-label`} className="block mb-1">
        {labelName}
      </label>
      <input
        id={`${UUID}-${name}`}
        aria-labelledby={`${UUID}-${name}-label`}
        type="date"
        placeholder="MM/DD/YYYY"
        aria-placeholder="MM/DD/YYYY"
        min={min}
        max={max}
        disabled={isDisabled}
        {...register(name, {
          ...validationsProps,
          onChange: (e) => {
            setValue(name, e.target.value);
          },
        })}
      />
      {validationMessage && <FormInputError errorMessage={validationMessage} />}
    </div>
  );
}
